module.exports = __webpack_public_path__ + "img/games-12.ce162147.jpg";